import ServerVersion from './server-version';

export default ServerVersion;
export { ServerVersion };



// WEBPACK FOOTER //
// ./src/components/server-version/index.js